import Indicator from '@/components/UI/Indicator';
import { AnimalAlertV1 } from '@/model/Alert.model';
import type { AnimalApiId } from '@/model/Animal.model';
import type { StudyApiId } from '@/model/Study.model';
import * as Auth from '@/support/auth';
import { useFetchContext } from '@/support/Hooks/fetch';
import { FC } from 'react';
import { useDispatch } from 'react-redux';

interface AnimalAlertsProps {
  animalName?: string;
  cageName?: string;
  animalApiId: AnimalApiId;
  alerts: Array<AnimalAlertV1>;
  reloadAlerts: () => void;
}

const AnimalAlerts: FC<AnimalAlertsProps> = ({
  animalName = '',
  cageName = '',
  animalApiId,
  alerts = [],
  reloadAlerts,
}) => {
  const dispatch = useDispatch();
  const context = useFetchContext();

  if (!context) {
    return null;
  }

  const { entity: study } = context;

  const {
    api_id: studyApiId,
    settings: { calculations },
  } = study;

  const isWriteUser = Auth.isWriteUserForStudy(study);

  const handleClick = () => {
    dispatch({
      type: 'OPEN_MODAL',
      modal: 'ANIMAL_ALERTS',
      props: {
        animalName,
        cageName,
        calculations,
        alerts,
        studyApiId: studyApiId as StudyApiId,
        animalApiId,
        isWriteUser,
        onModalClose: () => reloadAlerts?.(),
      },
    });
  };

  return <Indicator onClick={handleClick} counter={alerts.length} />;
};

export default AnimalAlerts;
